import React from "react"
import { PageContent } from "client/components"

import Drive from "./drive"
import Okr from "./okr"
import Rrs from "./rrs"
import Study from "./study"
import Task from "./task"
import Project from "./project"
import Cc from "./cc"
import Lifecycle from "./lifecycle"
import Sil from "./sil"
import Qid from "./qid"
import Markov from "./markov"

const Settings = () => (
    <PageContent>
        <Drive />
        <Okr />
        <Rrs />
        <Study />
        <Task />
        <Project />
        <Cc />
        <Lifecycle />
        <Sil />
        <Qid />
        <Markov />
    </PageContent>
)
export default Settings
